import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeAndSlideUp } from '@smartera/animations';
import { Oauth2Service } from '@api/services';
import { TokenService } from '@api/services/authorization/token.service';
import { UserService } from '@api/services/user/user.service';
import { LocalStorageService } from '@smartera/core';
import { LoginDialogService } from '@core/services/login-dialog.service';
import { UtilityService } from '@core/services/utility.service';
import { decodeHtmlTextMessage } from '@smartera/core';
import { BaseComponent } from '@modules/components/base-component';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	animations: [fadeAndSlideUp],
	standalone: false,
})
export class LoginComponent extends BaseComponent implements OnInit {
	isDemoMode = environment.demo;

	public form: FormGroup;
	public now: Date = new Date();
	loginForm: FormGroup;
	isRetryTimerEnds: boolean = false;
	timerLabel: string;
	loginParametersInfo: any;
	timer: number;
	timerForRetry: number;
	isExpired: boolean = false;
	mainCountDown: any;
	retryCountDown: any;
	counter = 0;
	loginErrorDialogMessage: string;
	isLoginErrorDialogVisible: boolean = false;
	customeLoginData: {
		email: string;
		dealerId: string;
		branchId: string;
		dealerName: string;
	} = JSON.parse(localStorage.getItem('customLogin') || '{}');
	isLoginedByToken = false;

	constructor(
		private _builder: FormBuilder,
		private _router: Router,
		private _loginDialogService: LoginDialogService,
		private activatedRoute: ActivatedRoute,
		private tokenService: TokenService,
		private oauth2Service: Oauth2Service,
		private userService: UserService,
		private localStorageService: LocalStorageService,
		utilServ: UtilityService
	) {
		super(null, utilServ);

		this.form = _builder.group({
			email: ['', [Validators.required]],
			password: ['', Validators.required],
			rememberMe: [true],
		});
		this.loginForm = this.utilServ.builder.group({
			code: [null, [Validators.required]],
		});

		if (this.isDemoMode) {
			this.form.reset({
				email: 'demo',
				password: 'Admin005',
			});
		}
	}

	public ngOnInit(): void {
		this.hideloader();
	}

	public login(): void {
		const formData: { email: string; password: string } = this.form.value;
		this.showLoader();
		this.oauth2Service
			.login(formData.email, formData.password)
			.pipe(
				catchError((e) => {
					const err: string = e.error.code;
					console.log(err);
					if (err === 'login.renew.password.exception') {
						this._router.navigate(['login/expire-password', formData.email]);
					} else {
						if (e.status === 401) {
							this.loginErrorDialogMessage = decodeHtmlTextMessage(e.error.message);
							this.isLoginErrorDialogVisible = true;
						}
					}

					//DEPRECETED OLAN ERROR FUNCTİON ARAŞTIRILMALI !!

					this.utilServ.alertService.error(this.t('failedLoginErrorMessage'), err);
					return observableThrowError(err);
				})
			)
			.subscribe(() => {
				this.tokenService.isTokenExpired.next(false);
				this.userService.getLoginParameters().subscribe(async (res) => {
					if (res.user2FARequired == true) {
						this.isDialogVisible = true;
						this.loginParametersInfo = res;
						this.startCountDown(res.user2FAExpirePeriodInSecond);
						this.startCountDownForRetry(res.user2FAExpirePeriodInSecond);
						this.hideloader();
					} else {
						await this.oauth2Service
							.fetchAndSetStorageUserInfo()
							.then(() => {
								this._router.navigateByUrl('/page');
							})
							.finally(() => {
								this.hideloader();
							});
					}
				});
			});
	}

	control(): void {
		const loginObject: any = {
			code: this.loginForm.get('code').value,
		};
		this.tokenService.unlockUser2Fa(loginObject).subscribe(async () => {
			this.showLoader();
			await this.oauth2Service
				.fetchAndSetStorageUserInfo()
				.then(() => {
					console.log('Giriş Başarılı. Anasayfaya yönlendiriliyor..');
					this._router.navigateByUrl('/page');
				})
				.finally(() => {
					this.hideloader();
				});
		});
	}

	resetAll(): void {
		this.loginForm.reset();
		this.isRetryTimerEnds = false;
	}

	retryToConnect(): void {
		this.tokenService.resend2Fa().subscribe(() => {
			this.userService.getLoginParameters().subscribe((res) => {
				clearInterval(this.mainCountDown);
				clearInterval(this.retryCountDown);
				this.startCountDown(res.user2FAExpirePeriodInSecond);
				this.isRetryTimerEnds = false;
				this.startCountDownForRetry(res.user2FAExpirePeriodInSecond);
			});
		});
	}

	private startCountDown(second: number): void {
		this.timer = second;
		this.mainCountDown = setInterval(() => {
			this.timer = this.timer - 1;
			if (this.timer == 0) {
				this.isExpired = true;
				clearInterval(this.mainCountDown);
			}
		}, 1000);
	}

	private startCountDownForRetry(second: number): void {
		this.timerForRetry = second;
		this.retryCountDown = setInterval(() => {
			this.timerForRetry = this.timerForRetry - 1;
			if (this.timerForRetry == 0) {
				this.isRetryTimerEnds = true;
				clearInterval(this.retryCountDown);
			}
		}, 1000);
	}

	get isLoginValid(): boolean {
		return this.form.invalid;
	}

	clearLoginData(): void {
		localStorage.removeItem('customLogin');
		this.customeLoginData = JSON.parse(localStorage.getItem('customLogin') || '{}');
		localStorage.removeItem('branch_dealer');
	}
}
